module.exports = __webpack_public_path__ + "static/media/centra-IoT-icon.812df327.png";